import { render, staticRenderFns } from "./InformationenPage.vue?vue&type=template&id=807020b6&scoped=true&"
import script from "./InformationenPage.vue?vue&type=script&setup=true&lang=ts&"
export * from "./InformationenPage.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./InformationenPage.vue?vue&type=style&index=0&id=807020b6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "807020b6",
  null
  
)

export default component.exports